/**
 * @deprecated SDK v1.2.0에서는 send() 메서드가 내부적으로 암호화를 처리합니다.
 * 이 함수들은 SecurePlayground 데모 용도로만 유지됩니다.
 *
 * 새로운 코드에서는 SDK의 send() 메서드를 직접 사용하세요.
 * 예: await sdk.send(sessionId, payload, { stream: true })
 */

// 암호화 함수 (SecurePlayground 데모용)
export async function encryptMessage(content, sdk) {
  if (!sdk) throw new Error('SDK가 초기화되지 않았습니다.');

  // SDK v1.2.0에서는 __encrypt__가 제거되었을 수 있음
  if (typeof sdk.__encrypt__ !== 'function') {
    console.warn('[encryptMessage] __encrypt__ 메서드를 사용할 수 없습니다. SDK v1.2.0에서는 send()가 내부적으로 암호화를 처리합니다.');
    return content;
  }

  return await sdk.__encrypt__(content);
}

// 복호화 함수 (SecurePlayground 데모용)
export async function decryptMessage(content, sdk) {
  if (!sdk) throw new Error('SDK가 초기화되지 않았습니다.');

  // SDK v1.2.0에서는 __decrypt__가 제거되었을 수 있음
  if (typeof sdk.__decrypt__ !== 'function') {
    console.warn('[decryptMessage] __decrypt__ 메서드를 사용할 수 없습니다. SDK v1.2.0에서는 응답이 자동으로 복호화됩니다.');
    return content;
  }

  return await sdk.__decrypt__(content);
}
